// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision.broadphase

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Interface that the application should implement to allow mapping object layers to broadphase layers
 *
 * C++ `JPH::BroadPhaseLayerInterface`.
 */
open class BroadPhaseLayerInterface internal constructor(internal val broadPhaseLayerInterfaceHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    /** Creates one whose functions a subclass overrides. */
    constructor() : this(JphBroadPhaseLayerInterface_createUpcalls(Upcalls.function), owned = true) {
        if (this::class != BroadPhaseLayerInterface::class) JphBroadPhaseLayerInterface_bindUpcalls(broadPhaseLayerInterfaceHandle, Upcalls.reference(this))
    }

    override fun close() =
        closeOnce { JphBroadPhaseLayerInterface_destroy(broadPhaseLayerInterfaceHandle) }

    /** Return the number of broadphase layers there are */
    open val numBroadPhaseLayers: Int
        get() = JphBroadPhaseLayerInterface_GetNumBroadPhaseLayers(broadPhaseLayerInterfaceHandle)

    /** Convert an object layer to the corresponding broadphase layer */
    open fun getBroadPhaseLayer(layer: Int): BroadPhaseLayer =
        BroadPhaseLayer(JphBroadPhaseLayerInterface_GetBroadPhaseLayer(broadPhaseLayerInterfaceHandle, layer))

    override fun nativeUpcall(method: Int, args: NativePointer, result: NativePointer): Boolean {
        when (method) {
            0 -> writeSlot(result, numBroadPhaseLayers.toLong())
            1 -> writeSlot(result, getBroadPhaseLayer(readSlot(args, 0).toInt()).value.toLong())
            else -> return false
        }
        return true
    }
}
